import { SearchForm } from "../components/SearchForm";

export function CandidateSearchPage() {
  return <SearchForm />;
}
